export default "__VITE_ASSET__ICBLRgN___"